<!-- Custom layout so the count pill + action buttons all sit on the far-right
     of the header in one line, no divider below. Costs and incomes share one
     card, the way the legacy Kalkulacija tab shared one table for both. The
     vehicle form has no income repeater, so it leaves `withIncome` off. -->
<section class="v2-stroski-card"
         [attr.data-field]="expenseRepeater?.fieldUuid"
         [attr.data-field-uuid]="expenseRepeater?.fieldUuid"
         [attr.data-typeId]="expenseRepeater?.config?.typeId">
  <header class="v2-stroski-card__header">
    <i class="fas fa-chart-line v2-stroski-card__icon"></i>
    @if (withIncome) {
      <span class="v2-stroski-card__title" i18n>Stroški in prilivi</span>
    } @else {
      <span class="v2-stroski-card__title" i18n>Stroški</span>
    }
    <span class="v2-stroski-card__spacer"></span>
    <span class="v2-stroski-card__count">{{ expenses.length + incomes.length }}</span>
    <button type="button" class="v2-stroski-card__add" [disabled]="isLocked" (click)="onAdd(expenseRepeater)">
      <i class="fas fa-plus"></i><span i18n>Dodaj strošek</span>
    </button>
    @if (withIncome) {
      <button type="button" class="v2-stroski-card__add" (click)="onAdd(incomeRepeater)">
        <i class="fas fa-plus"></i><span i18n>Dodaj priliv</span>
      </button>
    }
    <button type="button" class="v2-stroski-card__details-btn"
            [class.is-open]="detailsOpen"
            (click)="toggleDetails()">
      <span i18n>Podrobnosti</span>
      <i class="fas" [class.fa-chevron-up]="detailsOpen" [class.fa-chevron-down]="!detailsOpen"></i>
    </button>
  </header>

  <div class="v2-stroski-summary">
    @if (isLoading) {
      <span class="v2-skel-block" style="width: 100px; height: 22px; border-radius: 6px;"></span>
      <span class="v2-skel-block v2-skel-block--line v2-skel-block--w-120"></span>
    } @else {
      <span class="v2-stroski-summary__amount">{{ expensesTotal | number:'1.2-2' }}€</span>
      <span class="v2-stroski-summary__label" i18n>Skupni stroški</span>
      @if (withIncome) {
        <span class="v2-stroski-summary__amount v2-stroski-summary__amount--income">{{ incomesTotal | number:'1.2-2' }}€</span>
        <span class="v2-stroski-summary__label" i18n>Skupni prilivi</span>
      }
    }
  </div>

  <div class="v2-stroski-chips">
    @if (isLoading) {
      <!-- Shimmer chips replace "Ni stroškov" while the expenses repeater
           is in flight, so the empty-state copy doesn't flash early. -->
      <span class="v2-skel-block v2-skel-block--chip"></span>
      <span class="v2-skel-block v2-skel-block--chip"></span>
      <span class="v2-skel-block v2-skel-block--chip"></span>
    } @else {
      @for (e of expenses; track e.uuid) {
        <span class="v2-chip-blue" [style.color]="e.invalid ? '#dc2626' : null">
          @if (e.invalid) { <i class="fas fa-exclamation-circle"></i> }
          {{ e.name || expenseFallbackLabel }} {{ e.amount | number:'1.0-2' }}€
        </span>
      }
      @for (i of incomes; track i.uuid) {
        <span class="v2-chip-blue v2-chip-blue--income">{{ i.name || incomeFallbackLabel }} {{ i.amount | number:'1.0-2' }}€</span>
      }
      @if (expenses.length === 0 && incomes.length === 0) {
        @if (withIncome) {
          <span class="v2-stroski-empty" i18n>Ni stroškov ali prilivov</span>
        } @else {
          <span class="v2-stroski-empty" i18n>Niste vnesli še nobenega stroška.</span>
        }
      }
    }
  </div>

  @if (detailsOpen && (expenses.length > 0 || incomes.length > 0)) {
    <div class="v2-stroski-details">
      <div class="v2-stroski-details__head">
        <h4 class="v2-stroski-details__title" i18n>Podrobnosti</h4>
        @if (withIncome) {
          <label class="v2-stroski-filter">
            <span i18n>Filter:</span>
            <select [(ngModel)]="rowFilter">
              <option value="" i18n>Prikaži vse</option>
              <option value="cost" i18n>Prikaži samo stroške</option>
              <option value="income" i18n>Prikaži samo prilive</option>
            </select>
          </label>
        }
      </div>
      <div class="v2-stroski-table v2-stroski-table--header">
        <div i18n>NAZIV</div>
        <button type="button" class="v2-stroski-sort" (click)="toggleSort('amount')">
          <span i18n>ZNESEK</span>
          <i class="fas"
             [class.fa-sort]="sortColumn !== 'amount'"
             [class.fa-sort-up]="sortColumn === 'amount' && sortAsc"
             [class.fa-sort-down]="sortColumn === 'amount' && !sortAsc"></i>
        </button>
        <div i18n>DATOTEKE</div>
        <button type="button" class="v2-stroski-sort" (click)="toggleSort('date')">
          <span i18n>DATUM</span>
          <i class="fas"
             [class.fa-sort]="sortColumn !== 'date'"
             [class.fa-sort-up]="sortColumn === 'date' && sortAsc"
             [class.fa-sort-down]="sortColumn === 'date' && !sortAsc"></i>
        </button>
        <div></div>
      </div>
      @for (e of visibleRows(); track e.uuid) {
        <div class="v2-stroski-table">
          <div class="v2-stroski-table__name" [style.color]="e.invalid ? '#dc2626' : null">
            @if (e.invalid) { <i class="fas fa-exclamation-circle"></i> }
            {{ e.name || '—' }}
            @if (e.comment) {
              <p class="v2-stroski-table__comment">{{ e.comment }}</p>
            }
          </div>
          <div [class.v2-stroski-table__amount--income]="!e.isExpense">{{ e.amount | number:'1.0-2' }} €</div>
          <div>
            @for (f of e.files; track f.url) {
              <div>
                <a [href]="f.url" target="_blank" rel="noopener" class="v2-stroski-table__doc"
                   [title]="f.fileName">
                  {{ f.fileName }} <i class="fas fa-external-link-alt"></i>
                </a>
              </div>
            } @empty {
              —
            }
          </div>
          <div>
            @if (e.date) { {{ e.date | date:'d.M.yyyy H:mm' }} } @else { — }
          </div>
          <div class="v2-stroski-table__actions">
            <button type="button" class="v2-stroski-icon"
                    [disabled]="isLocked"
                    (click)="onEdit(e)"
                    title="Uredi" i18n-title
                    [attr.aria-label]="editExpenseAriaLabel">
              <i class="fas fa-pen"></i>
            </button>
            <button type="button" class="v2-stroski-icon v2-stroski-icon--danger"
                    [disabled]="isLocked"
                    (click)="onRemove(e)"
                    title="Izbriši" i18n-title
                    [attr.aria-label]="deleteExpenseAriaLabel">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      }
    </div>
  }
</section>
